/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from "react";

import { ListItemIcon, MenuItem, Typography } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  icon: {
    minWidth: theme.spacing(5),
  },
}));

export const MenuItemClickable = ({
  primaryText,
  leftIcon,
  clickHandler,
  ...props
}) => {
  const classes = useStyles();
  const { onClick } = props;

  const handleMenuTap = useCallback(
    (e) => {
      debugger;
      clickHandler && clickHandler();
      onClick && onClick(e);
    },
    [onClick]
  );

  return (
    <MenuItem onClick={handleMenuTap}>
      {leftIcon && (
        <ListItemIcon className={classes.icon}>{leftIcon}</ListItemIcon>
      )}
      <Typography variant="inherit" color="textSecondary">
        {primaryText}
      </Typography>
    </MenuItem>
  );
};
